<template>
    <Popup :priority="110" size="large" design="" :is-forced-visible="isLoading">
        <h3 class="txt-center no-space uppercase weight-500" style="color: #fff;">
            {{ $t('popupAutoLogin_message') }}
        </h3>
        <p class="txt-center no-space">
            <button class="btn transparent large loading"></button>
        </p>
    </Popup>
</template>

<script>
    import axios from 'axios';
    import jsonp from 'axios-jsonp';

    export default {
        name: 'AutoLogin',

        props: {
            autoLoginUrl: {type: String, required: true},
            finishLoginUrl: {type: String, required: true},
        },

        data() {
            return {
                isLoading: false,
            }
        },

        mounted() {
            axios({
                url: this.autoLoginUrl,
                adapter: jsonp,
            }).then(response => {
                if (response.data.hasOwnProperty('errors')) {
                    return;
                }
                this.isLoading = true;
                window.location = this.finishLoginUrl + '?login_token=' + response.data.payload;
            });
        },
    }
</script>
